// g3-telemetry app entry — the ONLY file in this module with bare-specifier
// imports. capture.js, widget.js and logger.js are all plain ESM with zero
// imports so each can run standalone (Deno edge function, Cloudflare Pages
// Function, or a Node test) with no bundler. This file is meant to be
// copied into a generated app's own src/g3-telemetry/ (see CONTRACT.md) and
// built by that app's own bundler, which resolves @rrweb/record and
// modern-screenshot from the app's own package.json dependencies.
import { record } from "@rrweb/record";
import { domToPng } from "modern-screenshot";
import { installG3Telemetry } from "./widget.js";

export function startG3Telemetry(opts) {
  return installG3Telemetry({ record, domToPng, ...opts });
}
